export const CONFIRM_NEWSLETTER_OPT_IN = 'AUTH/CONFIRM_NEWSLETTER_OPT_IN';
export const CONFIRM_NEWSLETTER_OPT_IN_PENDING = `${CONFIRM_NEWSLETTER_OPT_IN}_PENDING`;
export const CONFIRM_NEWSLETTER_OPT_IN_FULFILLED = `${CONFIRM_NEWSLETTER_OPT_IN}_FULFILLED`;
export const CONFIRM_NEWSLETTER_OPT_IN_REJECTED = `${CONFIRM_NEWSLETTER_OPT_IN}_REJECTED`;

export const confirmNewsletterOptIn = () => ({
  type: CONFIRM_NEWSLETTER_OPT_IN,
});
